'use client'

import { useSearchParams } from 'next/navigation'

import { BUILDER_EDIT_MODES } from '@/constants'

import { GENERATOR_SEARCH_PARAM } from '../../generatorTypes'
import { CreateModeGeneratorFooter } from './CreateModeGeneratorFooter'
import { EditModeGeneratorFooter } from './EditModeGeneratorFooter'
import { GeneratorFooterContainer } from './GeneratorFooterContainer'

export const GeneratorFooter = () => {
	const searchParams = useSearchParams()

	const isEditMode =
		searchParams.get(GENERATOR_SEARCH_PARAM.Target) &&
		searchParams.get(GENERATOR_SEARCH_PARAM.Edit) ===
			BUILDER_EDIT_MODES.CONTENT

	const isChangeTypeMode =
		searchParams.get(GENERATOR_SEARCH_PARAM.Target) !== null &&
		searchParams.get(GENERATOR_SEARCH_PARAM.Edit) ===
			BUILDER_EDIT_MODES.TYPE

	return (
		<GeneratorFooterContainer>
			{isEditMode ? (
				<EditModeGeneratorFooter />
			) : (
				<CreateModeGeneratorFooter
					isChangeTypeMode={isChangeTypeMode}
				/>
			)}
			<div className="h-safe-area-bottom desktop:h-0" />
		</GeneratorFooterContainer>
	)
}
